'use client';

import { createContext, ReactNode, useContext, useMemo } from 'react';
import { useGetSystemPreferencesQuery } from 'services/userProfileApi';

import { useAppSelector } from 'store/hooks';

const ShowSvcPriceContext = createContext<boolean>(true);

export const ShowSvcPriceProvider = ({ children }: { children: ReactNode }) => {
  const { data: sysPrefs } = useGetSystemPreferencesQuery('');
  const { userInfo } = useAppSelector((state) => state.persistAuth);
  const { guestInfo } = useAppSelector((state) => state.persistGuestAuth);

  const isLogged = Boolean(userInfo?.clid) && Boolean(userInfo?.token);
  const isGuestLogged = Boolean(guestInfo?.clid) && Boolean(guestInfo?.token);
  const isAuthenticated = isLogged || isGuestLogged;

  const showSvcPrice = useMemo(() => {
    if (process.env.NODE_ENV === 'development') return true;
    if (!sysPrefs) return true;
    return isAuthenticated
      ? sysPrefs.show_svc_price
      : sysPrefs.show_guest_svc_price;
  }, [sysPrefs, isAuthenticated]);

  return (
    <ShowSvcPriceContext.Provider value={showSvcPrice}>
      {children}
    </ShowSvcPriceContext.Provider>
  );
};

export const useShowSvcPrice = () => useContext(ShowSvcPriceContext);
